import React from 'react'
import MOBILE_NETWORKS from 'gpesa';

const NetworkSelector = ({ containerStyle, ...props }) => {
  return (
    <label style={containerStyle}>Kutoka: <small style={{ fontWeight: 'normal' }}>(mf. Vodacom)</small>
      <select
        name="network"
        {...props}
        defaultValue=""
      >
        <option value="" disabled>Chagua mtandao</option>
        {MOBILE_NETWORKS
          .filter(({ mobile_money }) => Boolean(mobile_money))
          .map(({ name, mobile_money }) => <option key={name} value={name}>{name} - {mobile_money}</option>)}
      </select>
    </label>
  );
}

export default NetworkSelector;
